export const SEARCH_DEBOUNCE_MS = 200;
